import React from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";

const variants = {
  brand:
    "bg-brand text-brand-foreground shadow-[0_8px_24px_-6px_hsl(var(--brand)/.6)] hover:brightness-110 active:brightness-95",
  primary:
    "bg-primary text-primary-foreground hover:opacity-90 active:opacity-80 shadow-sm",
  outline:
    "border border-border bg-transparent hover:bg-accent hover:text-accent-foreground",
  ghost: "hover:bg-accent hover:text-accent-foreground",
  light: "bg-white text-neutral-900 hover:bg-neutral-100 shadow-sm",
  subtle: "bg-secondary text-secondary-foreground hover:bg-accent",
  destructive: "bg-destructive text-destructive-foreground hover:brightness-110 shadow-sm",
};

const sizes = {
  sm: "h-9 px-3.5 text-sm rounded-lg",
  md: "h-11 px-5 text-sm rounded-xl",
  lg: "h-12 px-7 text-base rounded-xl",
  icon: "h-10 w-10 rounded-lg",
};

export function Button({
  as,
  to,
  href,
  className,
  variant = "brand",
  size = "md",
  loading = false,
  disabled,
  children,
  ...props
}) {
  const classes = cn(
    "inline-flex items-center justify-center gap-2 whitespace-nowrap font-semibold transition-all duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:opacity-50",
    variants[variant],
    sizes[size],
    className
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button className={classes} disabled={disabled || loading} {...props}>
      {loading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
}
